// import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,

    avatar_details: {
      name: '',
      action_gesture: ['m01.motion3.json', 'm02.motion3.json', 'm03.motion3.json', 'm04.motion3.json', 'm05.motion3.json'],
      idle_motion: ['idle01.motion3.json', 'idle02.motion3.json', 'idle03.motion3.json'],
      lip_sync_animation: false
    }
  },
  mutations: {
    INIT_EDIT_ANIMATED_AVATAR_DIALOG(state, payload) {
      state.visibility = true
      state.avatar_details.name = payload.avatar_name
    },
    SET_EDIT_ANIMATED_AVATAR_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_EDIT_ANIMATED_AVATAR_DIALOG(state) {
      state.visibility = false
      state.name = ''
    },

    SET_EDIT_ANIMATED_AVATAR_DIALOG_AVATAR_NAME(state, payload) {
      state.avatar_details.name = payload
    }
  },
  actions: {
    async renameAiAvatar({ commit }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.renaming'), loading: true })
        commit('SET_EDIT_ANIMATED_AVATAR_DIALOG_SUBMIT_BTN_DISABLE', true)

        setTimeout(() => {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.rename'), icon: 'check', timeout: '2000' })
          commit('RESET_EDIT_ANIMATED_AVATAR_DIALOG')
        }, 3000)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_EDIT_ANIMATED_AVATAR_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
